import { useState } from 'react'
import { useSnapshot } from 'valtio'
import styled from 'styled-components'
import { documentStore } from '../../../state/documentStore'
import useTranslation from '../../../hooks/useTranslation'
import MoveFolderModal from '../MoveFolderModal/MoveFolderModal'
import { Icon_Folder } from '../../../styles/icons'
import * as BsIcons from 'react-icons/bs'

const NavBar = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 1rem 0.5rem;
`

const Pill = styled.button`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  border: 1px solid ${({ theme }) => theme.border?.default || '#e5e7eb'};
  background: ${({ theme }) => theme.area?.highBg || '#f3f4f6'};
  color: ${({ theme }) => theme.font?.label || '#374151'};
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  flex: 1;
  min-width: 0;
  text-align: left;

  svg {
    flex-shrink: 0;
    opacity: 0.7;
    font-size: 0.9rem;
  }
`

const PathLabel = styled.span`
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const ChevronRight = styled(BsIcons.BsChevronDown)`
  margin-left: auto;
`

const ClearButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  border: none;
  background: ${({ theme }) => theme.area?.highBg || '#f3f4f6'};
  color: ${({ theme }) => theme.font?.subtle || '#6b7280'};
  cursor: pointer;
  font-size: 1.25rem;
  flex-shrink: 0;
`

const getDisplayPath = (path) => {
  if (!path) return null
  const segments = path.split(' / ').filter(Boolean)
  if (segments.length <= 2) return path
  return '… / ' + segments.slice(-2).join(' / ')
}

const MobileFolderNav = () => {
  const snap = useSnapshot(documentStore)
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  const displayPath = getDisplayPath(snap.selectedFolderPath)

  const handleSelect = (folder) => {
    if (folder === null) {
      documentStore.selectedFolderId = null
      documentStore.selectedFolderName = null
      documentStore.selectedFolderPath = null
    } else {
      documentStore.selectedFolderId = folder.id
      documentStore.selectedFolderName = folder.name
      documentStore.selectedFolderPath = folder.path || null
    }
    setOpen(false)
  }

  return (
    <>
      <NavBar>
        <Pill onClick={() => setOpen(true)}>
          {Icon_Folder}
          <PathLabel>{displayPath || t('document.folder.all')}</PathLabel>
          <ChevronRight />
        </Pill>
        {snap.selectedFolderId && (
          <ClearButton onClick={() => handleSelect(null)} aria-label={t('documents.browser.folderNav.clear')}>
            <BsIcons.BsX />
          </ClearButton>
        )}
      </NavBar>
      {open && (
        <MoveFolderModal
          navigateMode
          title={t('documents.browser.folderNav.title')}
          onClose={() => setOpen(false)}
          onConfirm={handleSelect}
        />
      )}
    </>
  )
}

export default MobileFolderNav
